import Link from "next/link";

interface RelatedService {
  tag: string;
  title: string;
  description: string;
  href: string;
}

interface RelatedServicesGridProps {
  items: RelatedService[];
}

export default function RelatedServicesGrid({ items }: RelatedServicesGridProps) {
  return (
    <div className="related-grid">
      {items.map((item) => (
        <Link className="related" href={item.href} key={item.title}>
          <span className="tg">{item.tag}</span>
          <h3>{item.title}</h3>
          <p>{item.description}</p>
          <span className="lnk">Service ansehen →</span>
        </Link>
      ))}
    </div>
  );
}
